
window.initHomeBannerSlider = function(sliderId) {
  var id = sliderId.slice(sliderId.indexOf('#') + 1);
  var elSwiper = document.getElementById(id);
  if (!elSwiper || elSwiper.className.indexOf('swiper-container-initialized') !== -1) {
    return false; 
  }
  return new Swiper(elSwiper, {
    navigation: {
      nextEl: sliderId + ' .oa-home-banner__nav-next',
      prevEl: sliderId + ' .oa-home-banner__nav-prev',
      disabledClass: 'oa-home-banner__nav--disabled',
      hiddenClass: 'oa-home-banner__nav--disabled'
    },
    pagination: {
      el: sliderId + ' .oa-home-banner__pagination',
      clickable: true,
      bulletClass: 'oa-home-banner__bullet',
      bulletActiveClass: 'oa-home-banner__bullet--active'
    },
    slidesPerView: 1,
    spaceBetween: 10,
    roundLengths: true, //prevent blurry text
    mousewheel: {
      forceToAxis: true,
      releaseOnEdges: true,
      invert: true
    },
    autoplay: {
      delay: 4000,
    },
    speed: 500,
    loop: true,
    lazyLoad: true,
    loadPrevNext: true,
  });
}

window.initProductSlider = function (sliderId) {
  var id = sliderId.slice(sliderId.indexOf('#') + 1);
  var elSwiper = document.getElementById(id);
  if (!elSwiper || elSwiper.className.indexOf('swiper-container-initialized') !== -1) {
    return false; 
  }
  return new Swiper(elSwiper, {
    navigation: {
      nextEl: sliderId + ' + .oa-product-slider__nav .oa-product-slider__nav-next',
      prevEl: sliderId + ' + .oa-product-slider__nav .oa-product-slider__nav-prev',
      disabledClass: 'oa-product-slider__nav--disabled',
      hiddenClass: 'oa-product-slider__nav--disabled'
    },
    scrollbar: {
      el: '.oa-product-slider__scrollbar',
      // dragClass: 'oa-product-slider__scrollbar-drag',
      enabled: false,
      dragSize: 40,
      draggable: true,
      snapOnRelease: true,
    },
    slidesPerView: 2.25,
    spaceBetween: 10,
    roundLengths: true, //prevent blurry text
    freeMode: true,
    freeModeSticky: false,
    mousewheel: {
      forceToAxis: true,
      releaseOnEdges: true,
      invert: true,
    },
    breakpoints: {
      992: {
        slidesPerView: 3.5,
        scrollbar: {
           dragSize: 60,
        }
      },
      1300: {
        slidesPerView: 4,
        scrollbar: {
           dragSize: 60,
        },
      },
    },
    lazyLoad: true,
    loop: true
  });
}

window.initLpSlider = function (sliderId, sliderPerViewXS, sliderPerViewMD, sliderPerViewLG) {
  var id = sliderId.slice(sliderId.indexOf('#') + 1);
  var elSwiper = document.getElementById(id);
  if (!elSwiper || elSwiper.className.indexOf('swiper-container-initialized') !== -1) {
    return false;
  }
  return new Swiper(elSwiper, {
    navigation: {
      nextEl: sliderId + ' + .oa-product-slider__nav .oa-product-slider__nav-next',
      prevEl: sliderId + ' + .oa-product-slider__nav .oa-product-slider__nav-prev',
      disabledClass: 'oa-product-slider__nav--disabled',
      hiddenClass: 'oa-product-slider__nav--disabled'
    },
    scrollbar: {
      el: '.oa-product-slider__scrollbar',
      // dragClass: 'oa-product-slider__scrollbar-drag',
      enabled: false,
      dragSize: 40,
      draggable: true,
      snapOnRelease: true,
    },
    /*enteredSlides: true,
    centeredSlidesBounds: true,*/
    slidesPerView: sliderPerViewXS,
    spaceBetween: 10,
    roundLengths: true, //prevent blurry text
    freeMode: true,
    freeModeSticky: false,
    mousewheel: {
      forceToAxis: true,
      releaseOnEdges: true,
      invert: true,
    },
    breakpoints: {
      992: {
        slidesPerView: sliderPerViewMD,
        scrollbar: {
          dragSize: 60,
        }
      },
      1300: {
        slidesPerView: sliderPerViewLG,
        scrollbar: {
          dragSize: 60,
        },
      },
    },
    lazyLoad: true
  });
}

window.onQuickAddSizeClicked = function (element, productId, productHandle) {
  var selectorContainer = '.oa-prdct20-fashion__quickadd-container',
      selectorItem = '.oa-quick-add__variants-item',
      selectorSizeItem = '.oa-quick-add__variants-size-wrapper .oa-quick-add__variants-item',
      selectorLengthTitle = '.oa-quick-add__title-length',
      selectorLengthWrapper = '.oa-quick-add__variants-length-wrapper',
      classSoldout = 'oa-quick-add__variants-item--soldout',
      classActive = 'oa-quick-add__variants-item--active',
      selectorItemActive = '.oa-quick-add__variants-item.oa-quick-add__variants-item--active',
      selectorWrapperDual = 'oa-prdct20-fashion__quickadd-container--duallogo';
  var elContainer = element.closest(selectorContainer);
  var size = element.dataset.quickaddSize.toLowerCase();
  var variants = JSON.parse(elContainer.dataset.variants).filter(function (variant) { return variant.title.toLowerCase().indexOf(size + ' -') === 0; });
  var elLengthWrapper = elContainer.querySelector(selectorLengthWrapper);
  var isDualLogo = elContainer.classList.contains(selectorWrapperDual);
//console.log(JSON.parse(elContainer.dataset.variants))
  if(isDualLogo){
    if(elLengthWrapper.querySelector(selectorItemActive) != null){
      elLengthWrapper.querySelector(selectorItemActive).classList.remove(classActive);
      
  var selectorDualTitle = '.oa-quick-add__title-duallogo',
      selectorDualWrapper = '.oa-quick-add__variants-duallogo-wrapper',
      elDualWrapper = elContainer.querySelector(selectorDualWrapper),
      elDualTitle = elContainer.querySelector(selectorDualTitle);
      elDualTitle.style.position = 'absolute';
      elDualTitle.style.zIndex = -1;
      elDualWrapper.style.position = 'absolute';
      elDualWrapper.style.zIndex = -1;
    }
  }
  
  Array.prototype.slice.call(elLengthWrapper.querySelectorAll(selectorItem)).forEach(function (el) {
    var length = el.dataset.quickaddLength.toLowerCase();
    if(isDualLogo){
      var dualVariants = variants.filter(function (variant) { return variant.title.toLowerCase().indexOf('- ' + length) !== -1; });

    var avilableLengths = [];
      
dualVariants.forEach(function(variant){
  if (!variant) {
      el.style.display = 'none'; 
      return;
    }
    el.style.display = null;
    var elSvg = el.querySelector('svg');
  //console.log(variant.title,variant.available)
  
    if (!variant.available && avilableLengths.indexOf(variant.title.split(' - ')[1]) == -1) {
      el.classList.add(classSoldout);
      el.setAttribute('disabled', true);
      elSvg.style.display = null;
      el.removeAttribute('data-quickadd-variant-selected-size');
      return;
    }
      avilableLengths.push(variant.title.split(' - ')[1])
      el.classList.remove(classSoldout);
      el.removeAttribute('disabled');
      elSvg.style.display = 'none';
      el.setAttribute('data-quickadd-variant-selected-size', size); 
    
});
      
    }else{
    var variant = variants.filter(function (variant) { return variant.title.toLowerCase().indexOf('- ' + length) !== -1; })[0];
    //console.log(variant)
    if (!variant) {
      el.style.display = 'none'; 
      return;
    }
    el.style.display = null;
    var elSvg = el.querySelector('svg');
    if (!variant.available) {
      el.classList.add(classSoldout);
      el.setAttribute('disabled', true);
      elSvg.style.display = null;
      el.removeAttribute('data-quickadd-variant-id');
      return;
    }
      //console.log(variant)
      el.classList.remove(classSoldout);
      el.removeAttribute('disabled');
      elSvg.style.display = 'none';
      el.setAttribute('data-quickadd-variant-id', variant.id); 
    }
  });
  
  Array.prototype.slice.call(elContainer.querySelectorAll(selectorSizeItem)).forEach(function (el) { el.classList.remove(classActive); });
  //console.log(Array.prototype.slice.call(elContainer.querySelectorAll(selectorSizeItem)))
  element.classList.add(classActive);
  var elLengthTitle = elContainer.querySelector(selectorLengthTitle);
  
  elLengthTitle.style.position = null;
  elLengthTitle.style.zIndex = null;
  elLengthWrapper.style.position = null;
  elLengthWrapper.style.zIndex = null;

}

window.onQuickAddLengthToDualClicked = function (element, productId, productHandle) {
  var selectorContainer = '.oa-prdct20-fashion__quickadd-container',
      selectorItem = '.oa-quick-add__variants-item',
      selectorLengthItem = '.oa-quick-add__variants-length-wrapper .oa-quick-add__variants-item',
      classSoldout = 'oa-quick-add__variants-item--soldout',
      classActive = 'oa-quick-add__variants-item--active';
  var elContainer = element.closest(selectorContainer);
  var length = element.dataset.quickaddLength.toLowerCase();
  var selectedSize = elContainer.querySelector('.oa-quick-add__variants-size-wrapper .oa-quick-add__variants-item--active').dataset.quickaddSize
  var variants = JSON.parse(elContainer.dataset.variants).filter(function (variant) {return variant.title.toLowerCase().indexOf(length + ' -') !== -1 && variant.title.toLowerCase().indexOf(selectedSize + ' -') === 0; });

  //console.log(variants)

  var selectorDualTitle = '.oa-quick-add__title-duallogo',
      selectorDualWrapper = '.oa-quick-add__variants-duallogo-wrapper',
      elDualWrapper = elContainer.querySelector(selectorDualWrapper);
   
  
  Array.prototype.slice.call(elDualWrapper.querySelectorAll(selectorItem)).forEach(function (el) {
    var logo = el.dataset.quickaddLogo.toLowerCase();
    var variant = variants.filter(function (variant) { return variant.title.toLowerCase().indexOf('- ' + logo) !== -1; })[0];
    
    
    if (!variant) {
      el.style.display = 'none'; 
      return;
    }
    el.style.display = null;
    var elSvg = el.querySelector('svg');
    
    if (!variant.available) {
      el.classList.add(classSoldout);
      el.setAttribute('disabled', true);
      elSvg.style.display = null;
      el.removeAttribute('data-quickadd-variant-id');
      return;
    }
    el.classList.remove(classSoldout);
    el.removeAttribute('disabled');
    elSvg.style.display = 'none';
    //console.log(variant)
    el.setAttribute('data-quickadd-variant-title', variant.title);
    el.setAttribute('data-quickadd-variant-id', variant.id);
  });
  
  Array.prototype.slice.call(elContainer.querySelectorAll(selectorLengthItem)).forEach(function (el) { el.classList.remove(classActive); });
  element.classList.add(classActive);
  
  var elDualTitle = elContainer.querySelector(selectorDualTitle);


  elDualTitle.style.position = null;
  elDualTitle.style.zIndex = null;
  elDualWrapper.style.position = null;
  elDualWrapper.style.zIndex = null;

}
window.onQuickAddLengthClicked = function (element, productHandle, productTitle, productImage) {
  var variantId = element.dataset.quickaddVariantId;
  if (!variantId) { return; }
  window.onQuickAddClicked(element, variantId, productHandle, productTitle, productImage);
}

window.onQuickAddDualLogoClicked = function (element, productHandle, productTitle, productImage) {
  var variantId = element.dataset.quickaddVariantId;
  //console.log(variantId,element.dataset.quickaddVariantTitle);
  //console.log(element);
  
  //return;
  if (!variantId) { return; }
  window.onQuickAddClicked(element, variantId, productHandle, productTitle, productImage);
}

function closeQuickAddSizeAndLength (prodid) {
  var selectorContainer = '.oa-prdct20-fashion__quickadd-container',
      selectorItem = '.oa-quick-add__variants-item',
      selectorSizeItem = '.oa-quick-add__variants-size-wrapper .oa-quick-add__variants-item',
      selectorLengthTitle = '.oa-quick-add__title-length',
      selectorLengthWrapper = '.oa-quick-add__variants-length-wrapper',
      selectorDualTitle = '.oa-quick-add__title-duallogo',
      selectorDualWrapper = '.oa-quick-add__variants-duallogo-wrapper',
      classSoldout = 'oa-quick-add__variants-item--soldout',
      classActive = 'oa-quick-add__variants-item--active';
  var element = document.querySelector('.oa-shop-grid__item[data-product-id="'+prodid+'"] .oa-prdct20-fashion__quickadd-container');
  var elContainer = element.closest(selectorContainer);
  var elLengthWrapper = elContainer.querySelector(selectorLengthWrapper);
  var isDualLogo = element.dataset.quickaddLogo !== undefined;


  if (!elLengthWrapper) { return; }
  elLengthWrapper.style.zIndex = -1;
  elLengthWrapper.style.position = 'absolute';
  var elLengthTitle = elContainer.querySelector(selectorLengthTitle);
  elLengthTitle.style.zIndex = -1;
  elLengthTitle.style.position = 'absolute';
  Array.prototype.slice.call(elLengthWrapper.querySelectorAll(selectorItem)).forEach(function (el) { el.style.display = 'none'; });
  Array.prototype.slice.call(elContainer.querySelectorAll(selectorSizeItem)).forEach(function (el) { el.classList.remove(classActive); });

    if(!isDualLogo){ return; }
      var elDualWrapper = elContainer.querySelector(selectorDualWrapper);
      var elDualTitle = elContainer.querySelector(selectorDualTitle);
    if (!elDualWrapper) { return; }
      elDualWrapper.style.zIndex = -1;
      elDualWrapper.style.position = 'absolute';
      elDualTitle.style.zIndex = -1;
      elDualTitle.style.position = 'absolute';
  
}

// window.onQuickAddClicked = function (element, variantId, productHandle, productTitle, productImage) {
//   var selectorContainer = '.oa-prdct20-fashion__quickadd-container',
//       classActive = 'oa-quick-add__variants-item--active',
//       classSuccess = 'oa-quick-add__success',
//       classAdding = 'oa-quick-add__success--adding',
//       classAdded = 'oa-quick-add__success--added';
//   if (element.classList.contains(classActive) || element.hasAttribute('disabled')) {
//     return;
//   }
//   var elContainer = element.closest(selectorContainer);
//   elContainer.style.opacity = 1;
//   element.classList.add(classActive);
//   var addToCartData = { id: variantId, quantity: 1 };
//   if (Cookies.get('adfb') !== undefined){
//     addToCartData = { id: variantId,
//                      quantity: 1,
//                      properties: {'ad': 'FB'}
//                     };
//   }else if(Cookies.get('adig') !== undefined){
//     addToCartData = { id: variantId,
//                      quantity: 1,
//                      properties: {'ad': 'IG'}
//                     };
//   }
//   axios.post('/cart/add.json', addToCartData)
//   .then(function (response) {
//     //console.log('quick add product', variantId);
//     var circleSvg = '<svg class="oa-quick-add__success--circle" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><circle cx="50" cy="50" r="25"></circle></svg>';
//     var loadingSvg = '<svg class="oa-quick-add__success--check" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg"><polyline points="11.6,20 15.9,24.2 26.4,13.8"></polyline></svg>';
//     var domString = '<div class="' + classSuccess + '">' + circleSvg + loadingSvg + '</div>';
//     var parser = new DOMParser();
//     var elSuccess = parser.parseFromString(domString, 'text/html').body.firstChild;
//     document.dispatchEvent(new CustomEvent('oa:addtocartsuccess', { detail: { quickadd: true, handle: productHandle, title: productTitle, image: productImage } }));
//     document.dispatchEvent(new CustomEvent('oa:addtocarttracking', { detail: { sku: response.data.sku, qty: '1', title: productTitle, prodID: response.data.product_id, variantID: response.data.variant_id } }));
//     element.appendChild(elSuccess);
//     elSuccess.classList.add(classAdding);
//     setTimeout(function () {
//       elSuccess.classList.add(classAdded);
//       setTimeout(function () {
//         window.oaHeader.showCartCheck(element, function () {
//           elSuccess.classList.remove(classAdding);
//           elSuccess.classList.remove(classAdded);
//           setTimeout(function () {
//             element.removeChild(elSuccess);
//             element.classList.remove(classActive);
//             closeQuickAddSizeAndLength(response.data.product_id);
//             elContainer.style.opacity = null;
//           }, 225);
//         }, true);
//       }, 225);
//     }, 1000);
//   })
//   .catch(function () {
//     element.classList.remove(classActive);
//     elContainer.style.opacity = null;
//   });
// }

window.onQuickAddToggle = function (element) {
  element.classList.toggle('oa-quick-add__toggle--active');
  $(element.nextElementSibling).slideToggle(225);
}

document.addEventListener('DOMContentLoaded', function () {
  var homeBanners = document.querySelectorAll('.swiper-container.oa-home-banner[id^="home_banner"]');
  homeBanners.forEach(homeBanner => {
    window.initHomeBannerSlider('#' + homeBanner.id);
  });

  // window.initProductSlider('#recom_slider_sportswear');
  // window.initProductSlider('#recom_slider');

  // setTimeout(function () {
  //   window.initProductSlider('#newin_slider_sportswear');
  //   window.initProductSlider('#newin_slider');
  // }, 400);

 
  if (window.initProductSlider) {
    var recoSliders = document.querySelectorAll('.swiper-container.oa-product-slider__swiper[id^="reco_slider"]');
    recoSliders.forEach(recoSlider => {
      window.initProductSlider('#' + recoSlider.id);
    });
    /*
    window.initLpSlider('#reco_slider--teasing-raw-1', 2, 4, 4);
    window.initLpSlider('#reco_slider--teasing-raw-2', 2, 4, 4);
    window.initLpSlider('#reco_slider--teasing-raw-3', 2, 4, 4);
     */
    
  } 

  setTimeout(function () {
    if (window.initCabSlider) {
      window.initCabSlider();
    }

  }, 500);
}, { passive: true });





function createHtml(variant,isShowPicturePDP,colorName,element="",isActive,isLimited=false){
  const changeColorAttr = element === "-sidebar"
    ? `onclick="sidebar.fashionColorChange('${variant.handle}')"`
    : `href="/products/${variant.handle}"`;
  let itemHtml
  if(isShowPicturePDP){
    let variantImage = variant.product_image;
    if (variant.tags.includes('colorvariant:4')) {
      variantImage = variant.images ? variant.images[3] : variant.product_image;
    } else if (variant.tags.includes('colorvariant:3') || variant.tags.includes('colorvariant:2')) {
      variantImage = variant.images ? variant.images[2] : variant.product_image;
    } else if (variant.tags.includes('colorvariant:5')) {
      variantImage = variant.images ? variant.images[4] : variant.product_image;
    }
    /*@click="sidebar.fashionColorChange(color.split('|')[1])" -sidebar*/

    itemHtml = `
              <div class="item${!variant.inventory_available ? ' item--sold-out' : ''} ${isActive ? ' active' : ''}"  onmouseover="writeColorNameHower( '${colorName}' , '${element}' , true , ${isShowPicturePDP} , ${isLimited})" onmouseout="writeColorNameHower('${colorName}' , '${element}', false , ${isShowPicturePDP} , ${isLimited} )">
                <a id="variant-${variant.handle}" 
                   class=" oa-picture-wrapper" 
                    ${changeColorAttr}
                   title="${colorName}">
                       ${!variant.inventory_available && !isShowPicturePDP ? `<svg  style="width: 100%; height: 100%; position: absolute; top: 0; bottom: 0; left: 0; right: 0; inset: 0;" fill="currentColor" stroke="currentColor">
                      <line x1="0" y1="100%" x2="100%" y2="0" style="stroke-width:1"></line>
                    </svg>` : ''}
                  <canvas class="oa-picture__canvas" width="1440" height="1800"></canvas>
                  <picture>
                    <source data-srcset="${variantImage}?width=200 1x, ${variantImage}?width=400 2x">
                    <img class="oa-picture__img oa-picture__img--cover lazy" 
                         data-src="${variantImage}?width=200" 
                         alt="${variant.title}">
                  </picture>
                </a>
              </div>
            `;
  }else{

    itemHtml = `
            <div class="sidebar--color-item-box" onmouseover="writeColorNameHower( '${colorName}' , '${element}' , true , ${isShowPicturePDP} , ${isLimited})" onmouseout="writeColorNameHower('${colorName}' , '${element}', false , ${isShowPicturePDP} , ${isLimited} )">  <a   ${changeColorAttr} style="order: 0;position: relative"  class="sidebar--color-item m-b-0 ${isActive ? ' active' : ''}">
                   
                <div style="position: relative;" class="sidebar--color-item-bg ${!variant.inventory_available ? ' item--sold-out' : ''}"
                     onmouseover="window.oaColorHover(this)" 
                     data-handle="${variant.handle}" data-bgcolor="${colorName}"
                     >
                     ${!variant.inventory_available && !isShowPicturePDP ? `<svg  style="color:white;width: 100%; height: 100%; position: absolute; top: 0; bottom: 0; left: 0; right: 0; inset: 0;" fill="currentColor" stroke="currentColor">
                      <line x1="0" y1="100%" x2="100%" y2="0" style="stroke-width:1"></line>
                    </svg>` : ''}
                     
                </div>
              </a><div class="sidebar--color-item-text m-b-5">${variant.tags && variant.tags.includes('new') ? 'new' : ''}</div></div>
            `;
  }
  return itemHtml;
} 
function createLoadMore(count,isLimited=false,element = "")
{
  return `<div class="oa-fashion-show-more-color" id="${isLimited?'oa-fashion-show-more-limited-color'+element:'oa-fashion-show-more-color'+element}">
    <div class="">
      <span>+${count}</span>
      <div
        class="oa-fashion-show-more-txt smaller">Colors</div>
    </div>
  </div>`
}
function ActiveLoadMore(count,isLimited=false,element = "")
{
 // console.log("ActiveLoadMore",count,isLimited,element)
  let productsContainer
  let showMoreBtn
if(isLimited){
   productsContainer = document.getElementById('fashion-color-limited-switch'+element);
   showMoreBtn = document.getElementById('oa-fashion-show-more-limited-color'+element);
}else{
   productsContainer = document.getElementById('fashion-color-switch'+element);
   showMoreBtn = document.getElementById('oa-fashion-show-more-color'+element);
}
 // console.log("productsContainer",productsContainer,showMoreBtn)
const allItems = Array.from(productsContainer.getElementsByClassName('item'));
const itemsPerRow = 6;
const visibleRows = 3;
const initialVisibleItems = (itemsPerRow * visibleRows)-1;
if(allItems.length<= initialVisibleItems){
  // showMoreBtn.style.display = 'none';
  return
}
//  console.log("allItems",allItems)
const calculateHeightForItems = (itemsCount) => {
  let height = allItems[0].offsetHeight+4
  return height * (itemsCount/itemsPerRow);
  productsContainer.style.overflow = ''
};
const initialHeight = calculateHeightForItems(initialVisibleItems+1);
productsContainer.style.height = `${initialHeight}px`;
// console.log("initialHeight",initialHeight)
showMoreBtn.addEventListener('click', () => {
  const fullHeight = calculateHeightForItems(allItems.length);
 // console.log("fullHeight",fullHeight)
  productsContainer.style.height = `${fullHeight}px`;
  showMoreBtn.style.display = 'none';

  productsContainer.style.overflow = '';
  setTimeout(()=>{
    productsContainer.style.height = `auto`;
  },220)
});
}
function renderLimitedEditionVariants(variants, isShowPicturePDP, productHandle, productTitle, element = "") {
  const currentProduct = productHandle;
  const isCurrentProductLimited = variants.some(v => v.handle === currentProduct);


  const limitedEditionHtml = `
          ${variants.map((variant, index) => {
    if (variant.handle === productHandle && element != "-sidebar") return;
    const titleParts = variant.title.split('|');
    const colorName = titleParts[1] ? titleParts[1].trim() : '';
    const isActive = variant.handle === currentProduct;
    if(variants.length>18 && isShowPicturePDP && index==17){
      let colorSwitch = document.getElementById('fashion-color-limited-switch'+element);
      colorSwitch.insertAdjacentHTML('beforeend', createLoadMore(variants.length-17,true,element ));
      
    }
    return createHtml(variant,isShowPicturePDP,colorName,element,variant.handle === productHandle,true);
  }).join('')}`;


  if (variants.length > 0) {
    document.querySelectorAll('.is-not-limited'+element).forEach(function(element) {
      element.classList.remove('d-none');
    });
    document.querySelectorAll('.is-limited'+element).forEach(function(element) {
      element.classList.add('d-none');
    });
    let colorSwitch = document.getElementById('fashion-color-limited-switch'+element);
    colorSwitch.insertAdjacentHTML('beforeend', limitedEditionHtml);
    if(variants.length>18 && isShowPicturePDP){
      ActiveLoadMore(variants.length,true,element)
    }
  }else{
    document.querySelectorAll('.is-not-limited'+element).forEach(function(element) {
      element.classList.add('d-none');
    });

    document.querySelectorAll('.is-limited'+element).forEach(function(element) {
      element.classList.remove('d-none');
    });
  }


}

function renderColorVariants(variants , isShowPicturePDP,productHandle,element="") {
  const currentProduct = productHandle;
  const colorSwitch = document.getElementById('fashion-color-switch'+element);
  if (!colorSwitch) return;
  const items = colorSwitch.querySelectorAll('.item:not(:first-child)');
  items.forEach(item => item.remove()); 
  let itemHtml="";
  var counter= 0
  variants.forEach((variant,index) => {
    if (variant.handle === productHandle && element != "-sidebar") return;
    counter++
    const titleParts = variant.title.split('|');
    const colorName = titleParts[1] ? titleParts[1].trim() : '';
    if(variants.length>18 && isShowPicturePDP && counter==17){
      colorSwitch.insertAdjacentHTML('beforeend', createLoadMore(variants.length-17,false,element ));
    }
    colorSwitch.insertAdjacentHTML('beforeend', createHtml(variant,isShowPicturePDP,colorName,element , variant.handle === productHandle,false));
  });
  if(variants.length>18 && isShowPicturePDP ){
  ActiveLoadMore(variants.length,false,element)
  }
  //  updateLazyLoad();
//    updateCurrentVariantTitle(variants);
  //   initializeColorSwitch();
}


async function initColorVariants(productTitle,isShowPicturePDP,productHandle,algoliaAppId,algoliaApiKey,algoliaIndex,element="") {
  let index
  let selectedColorData
  let response
  if(!window?.oaAlgolia?.activeIndex){
    const client = algoliasearch(algoliaAppId,algoliaApiKey);
    index = client.initIndex(algoliaIndex);
  }else{
    index = window?.oaAlgolia?.activeIndex
  }

  try {
    if(element == "-sidebar"){
      // console.log("bef filt",response)
      // response = response.hits.filter(hit => hit.inventory_available)

      if(colorsData){
        selectedColorData = findFirstMatchingParent(colorsData , productTitle[0].trim())
      }
      if(selectedColorData){
        response = selectedColorData?.hits
      }else{
        response = await index.search('', {
          filters: `tags:color-sorting AND meta.custom.nosto_title:'${removeWhiteLogo(productTitle[0].trim())}'`,
          ruleContexts:['color-sorting'],
          hitsPerPage: 1000,
        });
        response = await window.transformAppAlgoliaSearchResponse(response);
        response = await window.transformPreviewLaunchTagAlgoliaSearchResponse(response);
        response = response?.hits
      }

      //  console.log("after filt",response)
    }else{
      response = await index.search('', {
        filters: `tags:color-sorting AND meta.custom.nosto_title:'${removeWhiteLogo(productTitle[0].trim())}'`,
        ruleContexts:['color-sorting'],
        hitsPerPage: 1000,
      });
      response = await window.transformAppAlgoliaSearchResponse(response);
      response = await window.transformPreviewLaunchTagAlgoliaSearchResponse(response);
      response = response?.hits
    }
   
    if ( response) {

      const { regularVariants, limitedVariants } = separateVariants(response);
      renderLimitedEditionVariants(limitedVariants,isShowPicturePDP,productHandle,productTitle,element);
      renderColorVariants(regularVariants,isShowPicturePDP,productHandle,element);

    }
  } catch (error) {
    console.error('Error fetching color variants:', error);
  }
}
function createFirstElement(isShowPicturePDP, product, fashiontitleParts,element="") {
  let itemHtml = "";
  let colorSwitch;

  if (isShowPicturePDP) {
    let colorVariantImgMain = product.featured_image;
    if (product.tags.includes('colorvariant:4')) {
      colorVariantImgMain = product.images[3].src;
    } else if (product.tags.includes('colorvariant:3')) {
      colorVariantImgMain = product.images[2].src;
    } else if (product.tags.includes('colorvariant:2')) {
      colorVariantImgMain = product.images[2].src;
    } else if (product.tags.includes('colorvariant:5')) {
      colorVariantImgMain = product.images[4].src;
    }
    itemHtml = `<div class="item active">
          <a id="variant-${product.handle}"
             class="oa-picture-wrapper"
             href="/products/${product.handle}"
             title="${fashiontitleParts[1].trim()}">
            <canvas class="oa-picture__canvas" width="1440" height="1800"></canvas>
            <picture>
              <source data-srcset="${colorVariantImgMain}?width=200&height=200&scale=1 1x, ${colorVariantImgMain}?width=200&height=200&scale=2 2x">
                <img class="oa-picture__img oa-picture__img--cover lazy"
                     data-src="${colorVariantImgMain}?width=200&height=200"
                     alt="${product.title}">
            </picture>
          </a>
        </div>`;

  } else {

    itemHtml = `<div class="sidebar--color-item-box"><a href="/products/${product.handle}" class="sidebar--color-item m-b-0 active"><div class="sidebar--color-item-bg" onmouseover="window.oaColorHover(this)" data-handle="${product.handle}" data-bgcolor="${fashiontitleParts[1].trim()}"></div></a><div class="sidebar--color-item-text m-b-5">${product.tags.includes('new') ? 'new' : ''}</div></div>`;
  }
  document.getElementById('fashion-color-limited-switch'+element).innerHTML="";
  document.getElementById('fashion-color-switch'+element).innerHTML="";
  if (product.tags.includes('limited-edition')) {
    colorSwitch = document.getElementById('fashion-color-limited-switch'+element);
    document.getElementById('limited-color-text'+element).innerHTML = ' '+fashiontitleParts[1].trim();
    document.getElementById('regular-color-text'+element).innerHTML = '';
  } else {
    colorSwitch = document.getElementById('fashion-color-switch'+element);
    document.getElementById('limited-color-text'+element).innerHTML = '';
    document.getElementById('regular-color-text'+element).innerHTML = ' '+fashiontitleParts[1].trim();
  }
  if(element == "-sidebar"){return}
  colorSwitch.insertAdjacentHTML('beforeend', itemHtml);
}
function separateVariants(variants) {
  const regularVariants = [];
  const limitedVariants = [];

  variants.forEach(variant => {
    if (variant.tags.includes('limited-edition')) {
      limitedVariants.push(variant);
    } else {
      regularVariants.push(variant);
    }
  });

  return { regularVariants, limitedVariants };
}
function writeColorNameHower(colorName,element,status, isShowPicturePDP,isLimited=false ){ 
 //console.log("00000",colorName)
  if(isShowPicturePDP){
    if(status){
      if(!isLimited){
        document.getElementById('fashion-color-switch-item-title'+element).innerHTML =` ${colorName}`;
        document.getElementById('regular-color-text'+element).innerHTML =` ${colorName}`;
      }else{
        //todo limited version hover

      }

    }else{
      if(!isLimited){
        var color_switch_slider = document.getElementById('fashion-color-switch'+element);
        var color_items = Array.prototype.slice.call(color_switch_slider.querySelectorAll('.active .oa-picture-wrapper '));
        var current_title = color_items[0]?.getAttribute('title');
        //console.log("1111111",current_title)
        document.getElementById('fashion-color-switch-item-title'+element).innerHTML = current_title !== undefined ? ` ${current_title}` : ' ';
        document.getElementById('regular-color-text'+element).innerHTML = current_title !== undefined ? ` ${current_title}` : ' ';
        //  console.log("22222222",current_title)
      }else{
  //todo limited version hover
      }

    }
  }else{
    if(status){
      if(!isLimited){
        document.getElementById('fashion-color-switch-item-title'+element).innerHTML =` ${colorName}`;
        document.getElementById('regular-color-text'+element).innerHTML =` ${colorName}`;
      }else{
        document.getElementById('limited-color-text'+element).innerHTML =` ${colorName}`;

      }

    }else{
      if(!isLimited){
        var color_switch_slider = document.getElementById('fashion-color-switch'+element);
        var color_items = Array.prototype.slice.call(color_switch_slider.querySelectorAll('.sidebar--color-item-box .active .sidebar--color-item-bg '));
        var current_title = color_items[0]?.getAttribute('data-bgcolor');
        //console.log("1111111",current_title)
        document.getElementById('fashion-color-switch-item-title'+element).innerHTML = current_title !== undefined ? ` ${current_title}` : ' ';
        document.getElementById('regular-color-text'+element).innerHTML = current_title !== undefined ? ` ${current_title}` : ' ';
        //  console.log("22222222",current_title)
      }else{
        var color_switch_slider = document.getElementById('fashion-color-limited-switch'+element);
        var color_items = Array.prototype.slice.call(color_switch_slider.querySelectorAll('.sidebar--color-item-box .active .sidebar--color-item-bg '));
        var current_title = color_items[0]?.getAttribute('data-bgcolor');

        document.getElementById('limited-color-text'+element).innerHTML = current_title !== undefined ? ` ${current_title}` : ' ';
        // console.log("33333333",current_title)
      }

    }
  }

  
}
function changeActiveColor(handle, element, isShowPicturePDP,isLimited) {
  var color_switch_slider_el
  var other_color_switch_slider_el
  if(isLimited){
    color_switch_slider_el = document.getElementById('fashion-color-limited-switch'+element);
    other_color_switch_slider_el = document.getElementById('fashion-color-switch'+element);
  }else{
    color_switch_slider_el = document.getElementById('fashion-color-switch'+element);
    other_color_switch_slider_el = document.getElementById('fashion-color-limited-switch'+element);
  }
  const currentActive = color_switch_slider_el.querySelector('.sidebar--color-item.active');
  if (currentActive) {
    currentActive.classList.remove('active');
  }

  if (other_color_switch_slider_el) {
    other_color_switch_slider_el.querySelector('.sidebar--color-item.active')?.classList.remove('active');
  }
  const newActiveElement = color_switch_slider_el.querySelector(`[data-handle="${handle}"]`).parentElement;
  newActiveElement.classList.add('active');


  const colorName = color_switch_slider_el.querySelector(`[data-handle="${handle}"]`).getAttribute('data-bgcolor');


  if (!isLimited) {
    document.getElementById('limited-color-text' + element).innerHTML = "";
    document.getElementById('fashion-color-switch-item-title' + element).innerHTML = ` ${colorName}`;
    document.getElementById('regular-color-text' + element).innerHTML = ` ${colorName}`;
  } else {
    document.getElementById('fashion-color-switch-item-title' + element).innerHTML = "";
    document.getElementById('regular-color-text' + element).innerHTML = "";
    document.getElementById('limited-color-text' + element).innerHTML = ` ${colorName}`;
  }
}

var filterAnimation;
function initFilterAnimation() {
  if (typeof gsap === "undefined") {
    setTimeout(initFilterAnimation, 50);
    return;
  }
  filterAnimation = (function () {
    var sidebar = document.getElementById("shop-filter-sidebar");
    var collection = document.querySelector(".oa-shop-products-collection");
    var btnTextShow = Array.from(document.querySelectorAll(".filter-btn-label-show"));
    var btnTextHide = Array.from(document.querySelectorAll(".filter-btn-label-hide"));

    var openAnimation = gsap.timeline({
      paused: true,
      onComplete: function () {
        sidebar.style.overflow = "visible";
        sidebar.classList.add("visible");
        animationIsActive = false;
        window.dispatchEvent(new Event('resize'));
      }
    })
      .to(sidebar, {
        width: "20%",
        duration: 0.4,
        ease: "power1.inOut",
        marginRight: "30px",
        display: "block"
      })
      .to(sidebar, {
        height: "calc(100vh - 140px)",
        duration: 0.2,
        ease: "power1.inOut"
      }, 0.2)
      .to(collection, {
        width: "80%",
        duration: 0.2,
        ease: "power1.inOut"
      }, 0.2);

    var closeAnimation = gsap.timeline({
      paused: true,
      onComplete: function () {
        sidebar.classList.remove("visible");
        sidebar.style.display = "none";
        animationIsActive = false;
        window.dispatchEvent(new Event('resize'));
      }
    })
      .to(sidebar, {
        height: "0px",
        duration: 0.4,
        ease: "power1.inOut"
      })
      .to(sidebar, {
        width: "0%",
        // minWidth: "0",
        marginRight: "0px",
        duration: 0.2,
        ease: "power1.inOut"
      }, 0.2)
      .to(collection, {
        width: "100%",
        duration: 0.2,
        ease: "power1.inOut"
      }, 0.2);

    function openSidebar() {
      if (openAnimation.isActive() || closeAnimation.isActive()) {
        return; // Prevent overlapping animations
      }

      openAnimation.restart();

      collection.offsetHeight;
      btnTextShow.forEach((btn) => btn.classList.add("hidden"));
      btnTextHide.forEach((btn) => btn.classList.remove("hidden"));
      sidebar.dataset.collapsed = "false";
    }

    function closeSidebar() {
      if (openAnimation.isActive() || closeAnimation.isActive()) {
        return; // Prevent overlapping animations
      }

      closeAnimation.restart();

      collection.offsetHeight;
      btnTextShow.forEach((btn) => btn.classList.remove("hidden"));
      btnTextHide.forEach((btn) => btn.classList.add("hidden"));
      sidebar.dataset.collapsed = "true";
    }

    return {
      openSidebar: openSidebar,
      closeSidebar: closeSidebar
    };
  })();
}
initFilterAnimation();

function toggleFilterPLP() {
  var sidebar = document.getElementById("shop-filter-sidebar");

  // Ensure GSAP is loaded
  if (typeof gsap === "undefined") {
    console.error("GSAP is not loaded. Please include GSAP library.");
    return;
  }

  // Initialize if not already done
  if (!sidebar.dataset.initialized) {
    sidebar.style.overflow = "hidden";
    sidebar.dataset.initialized = "true";
    sidebar.dataset.collapsed = "true";
  }

  const isCollapsed = sidebar.dataset.collapsed === "true";
  sidebar.style.overflow = "hidden";
  sidebar.classList.remove("visible");

  if (isCollapsed) {
    filterAnimation.openSidebar();
  } else {
    filterAnimation.closeSidebar();
  }
}

// TODO: This could also be done with a js variable, that is set on page load and when filters are switched manually. Then it could also be used for showing the category title conditionally.
function isVersionA(element) {
  return $(element).parents('.oa-shop-filter__version-a').length > 0;
}

function toggleFilterPLPVerA() {
  const filterTitle = document.querySelector('.oa-shop-filter__title-plp');
  const filterMain = document.getElementById('oa-shop-filter__main');

  // Initialize if not already done
  if (!filterMain.dataset.initialized) {
    filterMain.style.transition = 'height 0.3s ease';
    filterMain.style.overflow = 'hidden';
    filterMain.dataset.initialized = 'true';
    filterMain.dataset.collapsed = 'false';
  }

  const isCollapsed = filterMain.dataset.collapsed === 'true';

  if (isCollapsed) {
    // Expand - temporarily remove height restriction to measure content
    filterMain.style.height = 'auto';
    const scrollHeight = filterMain.scrollHeight;
    filterMain.style.height = '0px';

    // Force reflow, then animate to full height
    filterMain.offsetHeight; // Trigger reflow
    filterMain.style.height = scrollHeight + 'px';

    // After animation completes, set to auto for responsive behavior
    setTimeout(() => {
      if (filterMain.dataset.collapsed === 'false') {
        filterMain.style.height = 'auto';
        filterMain.style.overflow = 'visible';
      }
    }, 300);

    filterMain.dataset.collapsed = 'false';
  } else {
    // Before collapsing, set explicit height and hidden overflow
    filterMain.style.height = filterMain.scrollHeight + 'px';
    filterMain.style.overflow = 'hidden';

    // Force reflow then collapse
    setTimeout(() => {
      filterMain.style.height = '0px';
    }, 10);

    filterMain.dataset.collapsed = 'true';
  }
}

window.setupFilterVersion = function (version) {
      if(version == 'a'){
        $('#oa-filter-sidebar').removeClass('oa-shop-filter__version-a');
        $('.oa-shop-filter__version-a').show(0);
        $('.oa-shop-filter__version-b').hide(0);
        $('#oa-filter-sidebar').addClass('oa-shop-filter__version-a');
      }else{
        $('#oa-filter-sidebar').removeClass('oa-shop-filter__version-a');
        $('.oa-shop-filter__version-a').hide(0);
        $('.oa-shop-filter__version-b').show(0);
      }
      // $('html').removeClass('header-version--a header-version--b');
      // $('html').addClass('header-version--' + version); 

      // $('.oa-hdr19').removeClass('oa-hdr19--version-a oa-hdr19--version-b');
      // $('.oa-hdr19').addClass('oa-hdr19--version-' + version); 
    }


document.addEventListener('DOMContentLoaded', function () {
  if (window.location.hash === '#filter-a') {
    if (typeof window.setupFilterVersion === 'function') {
      window.setupFilterVersion('a');
    }
  } else if (window.location.hash === '#filter-b') {
    if (typeof window.setupFilterVersion === 'function') {
      window.setupFilterVersion('b');
    }
  }
});